import React, {useEffect, useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  SafeAreaView,
  Platform,
  ScrollView,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import FastImage from '../../../common/FastImage';
import Header from '../../../commonComponents/Header';
import {
  buildLinkContest,
  timeLagFromCurrentTime,
  timeSinceCurrentTime,
  trackMoengageEvent,
} from '../../../utils/commonMethods';
import moment from 'moment';
import {
  contest_topup,
  cross_subcat,
  smile_coin_black,
  timer_icon,
} from '../../../utils/images';
import {Network} from '../../../utils/network';
import AboutTheContest from '../childComponents/AboutTheContest';
import ContestEventCards from '../childComponents/ContestEventCards';
import HowToContest from '../childComponents/HowToContest';
import LeaderBoard from '../childComponents/LeaderBoard';
import Colors from '../../../assets/Color/Colors';
import Width from '../../../assets/Width';
import CustomButton from '../../../commonComponents/CustomButton';
import CommonModal from '../../../commonComponents/commonModal';
import ContestStatus from '../childComponents/ContestStatus';
import {
  getCurrentRoute,
  navigationReset,
} from '../../../navigation/rootNavigation';
import {
  hideLoader,
  showLoader,
} from '../../../commonComponents/Loader/loader.actions';
import TimerComp from '../../../commonComponents/TimerComp';
import {useInitialiseSocketConnection} from '../../../common/initialiseSocketConnection';
import {globalImport} from '../../../common/globalImports';
import TopUp from '../childComponents/TopUp';
import {
  getContestCoinsBalance,
  setContestBalanceEmpty,
} from '../redux/contest.action';
import HowToTradeVideo from '../../home/childComponents/howToTradeVideo';
import {contestDummyBanners} from '../../home/home.constant';
import {globalConst} from '../../../utils/globalConstant';
import ShareLinkContest from '../childComponents/ShareLinkContest';
import BottomInfoContest from '../childComponents/BottomInfoContest';
import ContestAboutBox from '../childComponents/ContestAboutBox';
import Portfolio from '../../portfolio/Portfolio';
import ClosedContest from '../childComponents/closedContest';
import DeadSimpleChat from '../../../commonComponents/DeadSimpleChat';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {INDIA} from '../../../utils/constants';

// const ContestTabsNew = ["Events", "Closed Position", "Open Position"];

const ContestDetail = ({navigation, route}) => {
  const [selectedTab, setSelectedTab] = useState('Events');
  //const isNewFormat = contestDetail?.contest_format === "format1";
  const contestConfig = useSelector(
    state => state.utilReducer.globalConfigData?.contestConfig,
  );
  const userInfo = useSelector(({profile}) => profile.profileData);
  const dispatch = useDispatch();
  const contestId = route?.params?.contestId;
  const [contestDetail, setContestDetail] = useState(null);
  const [contestFormat, setContestFormat] = useState([]);
  const [joinContest, setJoinContest] = React.useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  // const ContestTabs =
  //   contestDetail?.contest_format === "format2"
  //     ? ContestTabsNew
  //     : ContestTabsOld;
  //const ws = useSelector(({ liveReducer }) => liveReducer?.wsRef);
  //useInitialiseSocketConnection(ws, true, contestId);
  const [topUpPopUp, setTopUpPopUp] = React.useState(false);
  const ContestTabsNew = ['Events', 'Closed Position', 'Open Position'];
  const ContestTabsOld = ['Events', 'LeaderBoard', 'Portfolio'];

  const contestBalanceData = useSelector(
    ({contestLeaderboardReducer}) =>
      contestLeaderboardReducer?.contestBalanceData,
  );
  const isAppLogin = useSelector(({utilReducer}) => utilReducer.isAppLogin);

  const onTopUpResponse = res => {
    setShowStatus(res?.data);
    dispatch(getContestCoinsBalance(contestId));
    // setTopUpPopUp(false);
  };

  const onJoinContestClose = () => {
    setShowStatus(null);
    setJoinContest(false);
  };

  const onTopUpClose = () => {
    setTopUpPopUp(false);
  };
  const onTabClick = val => {
    if (selectedTab !== val) {
      setSelectedTab(val);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setContestBalanceEmpty());
    };
  }, []);

  useEffect(() => {
    trackMoengageEvent('Contest Page Visit', {
      Page: 'Fantasy Detail',
      contestId: contestId,
    });
  }, []);

  let region = userInfo?.region_code ?? 'INDIA';
  const enterContest = async () => {
    if (!userInfo?.isProfileComplete) {
      onJoinContestClose();
      navigation.navigate('Profile');
      return;
    }
    const res = await Network.enterContest({contest_id: contestId}, true);
    if (res?.data) {
      trackMoengageEvent('Contest Joined', {
        contestId: contestId,
      });
      setShowStatus(res?.data);
      getDetail();
      dispatch(getContestCoinsBalance(contestId));
    }
  };

  useEffect(() => {
    //* to be checkd for app
    const currRoute = route?.name;
    const locationDiscard = window?.location?.pathname;
    if (
      !globalImport.isWeb ||
      (currRoute.includes('contestDetail') &&
        !locationDiscard.includes('Wallet'))
    ) {
      dispatch(showLoader());
    }
    getDetail();
    dispatch(getContestCoinsBalance(contestId));
  }, []);

  const getContestDetail = async data => {
    let res1;
    let tempFormat = !data?.is_participant
      ? ['Events']
      : data?.contest_format === 'format2'
      ? ContestTabsNew
      : ContestTabsOld;
    if (data?.room_id && globalImport.isWeb) {
      if (!data?.isLiveChatEnabled) {
        res1 = await Network.contestGetChat({
          roomId: data?.room_id,
          fantasy_id: data?.id,
          fantasy_type: 'contest',
        });
      }
      if (
        data?.is_participant &&
        (res1?.data?.success || data?.isLiveChatEnabled)
      ) {
        tempFormat.splice(1, 0, 'Live Chat');
      }
    }
    setContestFormat(tempFormat);
  };

  const getDetail = async () => {
    const res = await Network.getSelectedContestDetails(contestId);
    if (res?.data?.contests?.[0]) {
      const tempContestData = res?.data?.contests?.[0];
      setContestDetail(tempContestData);
      await getContestDetail(tempContestData);
    } else {
      navigationReset();
    }
    // if (res?.success) {
    //   setContestDetail(res?.contests[0]);
    // }
    const currRoute = route?.name;
    const locationDiscard = window?.location?.pathname;

    if (
      !globalImport.isWeb ||
      (currRoute.includes('contestDetail') &&
        !locationDiscard.includes('Wallet'))
    ) {
      dispatch(hideLoader());
    }
  };

  const shareMethod = async () => {
    dispatch(showLoader());
    trackMoengageEvent('Contest Invite', {
      userId: userInfo?.userid,
      contestId: contestId,
    });
    const link = buildLinkContest(
      contestId,
      contestDetail?.title,
      contestDetail?.sharelink,
      contestDetail?.prize_pool,
    );
    //hideLoader();
  };

  const onHTTClick = () => {
    setModalVisible(!modalVisible);
  };

  const child = (
    <ShareLinkContest
      contestName={contestDetail?.title}
      prizePool={contestDetail?.prize_pool}
      sharaebleLink={contestDetail?.sharelink}
    />
  );

  const TabOptions = () => {
    return (
      <View
        style={{
          flexDirection: 'row',
          marginHorizontal: 15,
          marginTop: 50,
          paddingTop: 10,
          //paddingTop: 50,
          backgroundColor: 'white',
          zIndex: 15,
        }}>
        <FlatList
          horizontal
          contentContainerStyle={{flexGrow: 1}}
          data={contestFormat}
          renderItem={item => {
            const isSelected = item?.item === selectedTab;
            if (
              (item?.item === 'Open Position' || item?.item === 'Portfolio') &&
              !contestDetail?.is_participant
            ) {
              return null;
            }
            return (
              <TouchableOpacity
                onPress={() => {
                  onTabClick(item?.item);
                }}
                style={[
                  globalStyle.outerElementBox,
                  styles.headerOption,
                  isSelected ? styles.headerOptionsSelected : {},
                ]}>
                <Text
                  style={[
                    styles.tabText,
                    isSelected ? {color: Color.bgWhite} : null,
                  ]}>
                  {item?.item}
                </Text>
              </TouchableOpacity>
            );
          }}
          //keyExtractor={txn => txn.id}
          showsHorizontalScrollIndicator={false}
        />
      </View>
    );
  };

  return (
    <SafeAreaView style={[globalStyle.pageContainer, {flexGrow: 1}]}>
      <ScrollView
        style={globalStyle.pageContainer}
        overScrollMode="never"
        nestedScrollEnabled={Platform.OS !== 'web'}
        keyboardShouldPersistTaps={'handled'}
        stickyHeaderIndices={[2]}
        //style={{width: '100%'}}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          flexGrow: 1,
          paddingBottom: selectedTab === 'Live Chat' ? 0 : 120,
        }}
        // scrollEnabled={selectedTab === 2}
      >
        <Header
          isInternalPage={false}
          navigation={navigation}
          pageName={''}
          backGroundColor={'#FFFFFF'}
          isCheckGoBack={true}
          shareMethod={contestDetail?.sharelink ? shareMethod : undefined}
          children={child}
          onHTTClick={onHTTClick}
          httTitle={'How it works?'}
          btnTitle={'Invite Friend'}
          translate={true}
        />
        <ContestAboutBox
          contestDetail={contestDetail}
          setJoinContest={setJoinContest}
          contestBalanceData={contestBalanceData}
          activeContest={true}
          isAppLogin={isAppLogin}
          navigation={navigation}
        />
        <TabOptions />

        <View
          style={{
            marginTop:
              selectedTab === 'Open Position' || selectedTab === 'Portfolio'
                ? 0
                : 20,
            paddingHorizontal: 15,
            flex: 1,
          }}>
          {selectedTab === 'Events' && (
            <ContestEventCards
              isParticipent={contestDetail?.is_participant}
              contestId={contestId}
              navigation={navigation}
              contestStartTime={contestDetail?.start_time}
            />
          )}
          {(selectedTab === 'Closed Position' ||
            selectedTab === 'LeaderBoard') && (
            <>
              {contestDetail?.contest_format === 'format2' ? (
                <View style={{flex: 1}}>
                  <ClosedContest contestId={contestId} />
                </View>
              ) : (
                <View style={{flex: 1}}>
                  <LeaderBoard contestId={contestId} />
                </View>
              )}
            </>
          )}
          {(selectedTab === 'Open Position' || selectedTab === 'Portfolio') && (
            <View style={{flex: 1}}>
              <Portfolio contestParentId={contestId} />
            </View>
          )}
          {selectedTab === 'Live Chat' && (
            <View style={{flex: 1}}>
              <DeadSimpleChat
                roomId={contestDetail?.room_id}
                channelId={contestDetail?.channel_id}
                userId={userInfo?.userid}
              />
            </View>
          )}
        </View>
      </ScrollView>
      {(selectedTab === 'Closed Position' || selectedTab === 'LeaderBoard') &&
        !contestDetail?.contest_format === 'format2' && <BottomInfoContest />}
      <CommonModal
        onModalCallBack={onHTTClick}
        customModalStyle={[globalStyle.modalView, {paddingTop: 0}]}
        showModal={modalVisible}>
        <HowToContest
          isBottomSheet={true}
          isShowCTA={false}
          coinsTobeAdded={contestBalanceData?.coinsTobeAdded}
        />
      </CommonModal>
      <CommonModal
        onModalCallBack={onJoinContestClose}
        customModalStyle={[styles.modalView]}
        showModal={joinContest}>
        {showStatus ? (
          <ContestStatus
            onDoneClick={onJoinContestClose}
            apiRespnseUiData={showStatus}
          />
        ) : (
          <View>
            <FormTextLabel
              labelStyles={{
                ...globalFontStyle.appFontHeading,
                backgroundColor: Colors.grey3,
                paddingVertical: 20,
                marginTop: -16,
                flex: 1,
                textAlign: 'center',
              }}
              label={'Contest Joining Confirmation'}
            />
            <View
              style={{
                marginHorizontal: 15,
                paddingVertical: 20,
                borderStyle: 'dashed',
                borderBottomWidth: 1,
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}>
              <FormTextLabel
                labelStyles={{...globalFontStyle.appFontBody}}
                label={'Entry'}
              />
              <View style={{flexDirection: 'row', alignItems: 'center'}}>
                <FastImage
                  style={{width: 15, height: 15, marginRight: 4}}
                  source={smile_coin_black()}
                />
                <Text style={{...globalFontStyle.appFontBody}}>
                  {contestDetail?.entry_fee}
                </Text>
              </View>
            </View>
            <View
              style={{
                marginHorizontal: 15,
                paddingVertical: 20,
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}>
              <FormTextLabel
                labelStyles={{...globalFontStyle.appFontSubHeading}}
                label={'To Pay'}
              />
              <View style={{flexDirection: 'row', alignItems: 'center'}}>
                <FastImage
                  style={{width: 15, height: 15, marginRight: 4}}
                  source={smile_coin_black()}
                />
                <Text style={{...globalFontStyle.appFontSubHeading}}>
                  {contestDetail?.entry_fee}
                </Text>
              </View>
            </View>
            <CustomButton
              btnText={'Confirm'}
              btnType={'btnBlack'}
              onBtnClick={enterContest}
              customStyle={[styles.buttonDesign]}
              translate={true}
            />
          </View>
        )}
      </CommonModal>
    </SafeAreaView>
  );
};

export default ContestDetail;

const styles = StyleSheet.create({
  timerIndicator: {},
  tabText: {
    ...globalFontStyle.appFontSubHeading,
    color: Color.black2,
    textAlign: 'center',
  },
  tipTimerTestStyle: {
    ...globalFontStyle.appFontSubText,
    color: Color.blue1,
  },
  headerOption: {
    paddingHorizontal: 15,
    height: 40,
    marginRight: 10,
  },
  topUpBtn: {
    backgroundColor: Colors.bgWhite,
    borderColor: Colors.black,
    paddingHorizontal: 15,
    borderRadius: 5,
    borderWidth: 0.75,
    paddingVertical: 10,
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerOptionsSelected: {
    backgroundColor: Colors.black,
  },
  modalView: {
    backgroundColor: 'white',
    paddingHorizontal: 0,
    paddingTop: 16,
    paddingBottom: 0,

    position: 'absolute',
    width: Width.width,

    bottom: 0,
    alignItems: 'stretch',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 6,
  },
  topContainer: {
    backgroundColor: 'rgba(10,87,255,.05)',
    paddingHorizontal: 15,
    paddingVertical: 15,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  bottomContainer: {
    paddingHorizontal: 15,
    paddingVertical: 15,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  buttonDesign: {
    flex: 1,
    marginTop: 0,
    marginHorizontal: 15,
    marginBottom: 15,
    paddingVertical: 15,
  },
});
